import React from "react";
import { Popover } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const WidgetInfoIcon = ({ title, widgetInfo }) => {
  const info = widgetInfo[title];
  if (!info) return null;

  const popover = (
    <Popover id={`popover-${title}`} style={{ maxWidth: "320px" }}>
      <Popover.Header as="h6" className="fw-bold">
        {title}
      </Popover.Header>
      <Popover.Body className="small">
        <p className="mb-2 text-muted">{info.description}</p>

        <div className="mb-2">
          <span className="fw-semibold">Formula: </span>
          <code className="text-danger">{info.formula}</code>
        </div>

        <div>
          <span className="fw-semibold">Conditions:</span>
          <ul className="mb-0 ps-3 mt-1">
            {info.conditions.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
      <span
        className="ms-1 text-muted"
        style={{ cursor: "pointer", fontSize: "0.75rem" }}
        onClick={(e) => e.stopPropagation()}
        title="What is this?"
      >
        <i className="fa-solid fa-circle-info" />
      </span>
    </OverlayTrigger>
  );
};

export default WidgetInfoIcon;